export class MidiPlayer {
    constructor({ encodeMidiMessage, json, midiFileSlicer, midiOutput, scheduler }) {
        this._encodeMidiMessage = encodeMidiMessage;
        this._endedTracks = null;
        this._json = json;
        this._midiFileSlicer = midiFileSlicer;
        this._midiOutput = midiOutput;
        this._offset = null;
        this._resolve = null;
        this._scheduler = scheduler;
        this._schedulerSubscription = null;
    }
    play() {
        if (this._schedulerSubscription !== null || this._endedTracks !== null) {
            throw new Error('The player is currently playing.');
        }
        this._endedTracks = 0;
        return new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._schedulerSubscription = this._scheduler.subscribe({
                complete: () => { },
                error: (err) => reject(err),
                next: ({ end, start }) => {
                    if (this._offset === null) {
                        this._offset = start;
                    }
                    this._schedule(start, end);
                }
            });
            if (this._resolve === null) {
                this._schedulerSubscription.unsubscribe();
            }
        });
    }
    _schedule(start, end) {
        if (this._endedTracks === null || this._offset === null || this._resolve === null) {
            throw new Error(); // @todo
        }
        const events = this._midiFileSlicer.slice(start - this._offset, end - this._offset);
        events
            .filter(({ event }) => MidiPlayer._isSendableEvent(event))
            .forEach(({ event, time }) => this._midiOutput.send(this._encodeMidiMessage(event), start + time));
        const endedTracks = events.filter(({ event }) => MidiPlayer._isEndOfTrack(event)).length;
        this._endedTracks += endedTracks;
        if (this._endedTracks === this._json.tracks.length) {
            if (this._schedulerSubscription !== null) {
                this._schedulerSubscription.unsubscribe();
            }
            this._schedulerSubscription = null;
            this._endedTracks = null;
            this._resolve();
            this._resolve = null;
        }
    }
    static _isEndOfTrack(event) {
        return 'endOfTrack' in event;
    }
    static _isSendableEvent(event) {
        return 'controlChange' in event || 'noteOff' in event || 'noteOn' in event || 'programChange' in event;
    }
}
//# sourceMappingURL=/build/es2019/midi-player.js.map